import { render, staticRenderFns } from "./ThaiAddressInput.vue?vue&type=template&id=21296984&scoped=true&"
import script from "./ThaiAddressInput.vue?vue&type=script&lang=js&"
export * from "./ThaiAddressInput.vue?vue&type=script&lang=js&"
import style0 from "./ThaiAddressInput.vue?vue&type=style&index=0&id=21296984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21296984",
  null
  
)

export default component.exports